import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL;

export async function getExtraWorkList() {
  const response = await api.get(`${API_URL}/extra-work/list.php`);
  return response.data;
}
